import { render, staticRenderFns } from "./p14.vue?vue&type=template&id=1b4f6617&scoped=true&"
import script from "./p14.vue?vue&type=script&lang=js&"
export * from "./p14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f6617",
  null
  
)

export default component.exports